import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, FloatingLabel, Alert } from "react-bootstrap";
import PageTitle from './components/PageTitle';
import { API_ENDPOINTS } from './config/api';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const res = await fetch(`${API_ENDPOINTS.AUTH}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Failed to process request");
        return;
      }

      setMessage("Password reset instructions have been sent to your email.");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setError("Network error. Please try again.");
      console.error("Password reset error:", err);
    }
  };

  return (
    <Container fluid className="d-flex align-items-center justify-content-center min-vh-100">
      <PageTitle title="Forgot Password" description="Reset your MedHive account password" />
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={8} md={6} lg={4} xl={3} style={{ width: "400px" }}>
          <Card className="shadow-lg border-0 rounded-4 p-md-5 p-4">
            <Card.Header className="p-0 text-center border-0 mb-4 mt-md-0 mt-2">
            <h5 className="text-center fw-semibold mb-0 ">
                Password Reset
              </h5>
              <p className="text-muted mb-0 text-center">Enter your email to reset your password</p>
            </Card.Header>
            <Card.Body className="p-0">
              
              {error && (
                <Alert variant="danger" className="text-center mb-3">
                  {error}
                </Alert>
              )}

              {message && (
                <Alert variant="success" className="text-center mb-3">
                  {message}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group>
                 <FloatingLabel controlId="floatingInput" label="Email address" className="mb-3">
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                  />
                  </FloatingLabel>
                </Form.Group>

                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-100 py-2 fw-semibold mb-3"
                >
                  Send Reset Instructions
                </Button>

                <div className="d-flex justify-content-center align-items-center login-signup-link">
                  <span className="me-1 text-muted small">Remember your password?{" "}</span>
                  <Button 
                    variant="link"
                    size="sm"
                    onClick={() => navigate("/login")}
                    className="text-decoration-none p-0"
                  >
                    Sign in
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword; 